/**
 * Base class for client-server processing
 * 
 * Helper:https://github.com/axios/axios/issues/897#issuecomment-343715381
 */
import Vue from 'vue'
//import CONFIG from '@/constants/config.js';
export default class{

    static getUpdateModel(id,value){
        let newId={id:id};
        return {
          val:value,
          data:newId
        };
    }

    static getBy(attr,dataset,id){
        let res=null;
        if(dataset && attr){
            res= Vue._.find(dataset,(obj)=>{
                return obj[attr]==id
            });
        }
        return res;
    }

    static getIndexById(dataset,id){
        return Vue._.findIndex(dataset, { 'id': id });
    }
    
    static addToState (state, attr,val) {
        if(!Vue._.isEmpty(val)&&!Vue._.isEmpty(attr)){
            let index=this.getIndexById(state[attr],val.id);
            if(index>-1){
                Vue.set(state[attr], index,val);
            }else{
                state[attr].push(val);
            }
        }
    }

    static deleteFromState (state, attr,val) {
        if(!Vue._.isEmpty(val)&&!Vue._.isEmpty(attr)){
            let index=this.getIndexById(state[attr],val.id);
            if(index>-1){
                Vue.delete(state[attr], index)
            }
        }
    }

    static updateOnState(state,attr, updateData){

        if(!Vue._.isEmpty(updateData) && updateData.val){

            let index=this.getIndexById(state[attr],updateData.val.id);
            if(index>-1){
                updateData.data=(updateData.data)?updateData.data:{};
                //Merge and override array
                Vue.set(state[attr], index,Vue._.mergeWith(updateData.val,updateData.data,(objValue, srcValue)=>{
                if (Vue._.isArray(srcValue)) {
                    return objValue = srcValue;
                }
                }));
            }
        }
    }
}